<button
  mat-raised-button color="primary"
  (click)="call()">
  Call WebRTC
</button>
